import styled from 'styled-components';

// CONSTANTS
import { theme } from '../../constants/theme';

// INTERFACES
import { IInput } from '../../interfaces/Input.interface';

export const Container = styled.div<IInput>`
  display: inline-flex;
  position: relative;
  flex-wrap: wrap;
  width: ${({ width }) => (!!width ? width : '100%')};
  margin-bottom: 16px;
  flex-direction: column;
`;

export const Label = styled.label<IInput>`
  display: inline-block;
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.semibold};
  color: ${theme.colors.secondary.gray100};
  font-size: 12px;
  line-height: 22px;
  ${({ errored, erroredexternal }) =>
    (errored || erroredexternal) &&
    `
    color: ${theme.colors.secondary.gray200};
  `}
  ${({ isDisabled }) =>
    isDisabled &&
    `
    color: ${theme.colors.secondary.gray300};
  `}
`;

export const SubLabelText = styled.p<IInput>`
  display: flex;
  justify-content: space-between;
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.semibold};
  font-size: 12px;
  line-height: 22px;
  color: ${theme.colors.secondary.gray300};
  margin: 0;
`;

export const OptionalLabel = styled.p<IInput>`
  display: inline-block;
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.semibold};
  color: ${theme.colors.secondary.gray300};
  font-size: 12px;
  line-height: 22px;
`;

export const InputContainer = styled.div`
  display: block;
`;

export const LabelContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledInput = styled.input<IInput>`
  padding: 16px;
  outline: 0;
  display: inline-block;
  width: 100%;
  max-width: 100%;
  background: ${theme.colors.primary.white};
  border: 1px solid ${theme.colors.secondary.gray500};
  box-sizing: border-box;
  border-radius: 8px;
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.regular};
  font-size: 14px;
  line-height: 24px;
  color: ${theme.colors.secondary.gray300};
  &:active {
    color: ${theme.colors.primary.black};
    border-color: ${theme.colors.secondary.blue200};
  }
  &:disabled {
    color: ${theme.colors.secondary.gray300};
    border-color: ${theme.colors.secondary.gray500};
    background: ${theme.colors.primary.lightGray};
  }
  &:valid {
    color: ${theme.colors.primary.black};
    border-color: ${theme.colors.secondary.gray500};
  }
  &:focus {
    color: ${theme.colors.secondary.gray300};
    border: 1px solid ${theme.colors.secondary.blue200};
    box-shadow: 0px 0px 0px 2px ${theme.colors.secondary.blue500};
  }
  &:not(:focus) {
    ${({ haserror, errored, erroredexternal }) =>
      (haserror || errored || erroredexternal) &&
      `
    border-color: ${theme.colors.secondary.red200} !important;
  `}
  }
`;

export const Error = styled.span`
  display: flex;
  color: ${theme.colors.secondary.red200};
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.semibold};
  font-size: 12px;
  line-height: 22px;
  margin-bottom: 8px;
`;

export const CheckMarkContainer = styled.div`
  position: absolute;
  width: 2rem;
  height: 2rem;
  bottom: 13px;
  right: 16px;
`;

export const PasswordContainer = styled.div`
  position: absolute;
  width: 2rem;
  height: 2rem;
  bottom: 14px;
  right: 10px;
  cursor: pointer;
`;
